import React from 'react';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ButtonBase from '@material-ui/core/ButtonBase';
import Button from '@material-ui/core/Button';

import Avatar from '../../components/Avatar';

const styled = withStyles(theme => {
  return {
    container: {
      overflowX: 'auto'
    },
    table: {
      margin: '0px auto'
    },
    tableHead: {
      backgroundColor: '#fff'
    },
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    timeAgo: {
      whiteSpace: 'nowrap'
    },
    user: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  };
});

class TabReports extends React.Component {
  renderRow(data) {
    const { classes } = this.props;

    return (
      <TableRow key={data.id}>
        <TableCell padding="dense">
          <Typography className={classes.timeAgo}>
            {moment(data.createTime).fromNow()}
          </Typography>
        </TableCell>
        <TableCell padding="dense">
          <Typography>{data.dismissed ? 'YES' : 'NO'}</Typography>
        </TableCell>
        <TableCell padding="dense">
          <Typography>{data.reason}</Typography>
        </TableCell>
        <TableCell padding="dense">
          {data.matchId ? (
            <Button
              variant="outlined"
              size="small"
              component={Link}
              to={'/matches/' + data.matchId}
            >
              Match
            </Button>
          ) : (
            <div />
          )}
        </TableCell>
        <TableCell padding="dense">
          <Typography>{data.message}</Typography>
        </TableCell>
        <TableCell padding="dense">
          <ButtonBase
            component={Link}
            to={`/users/${data.fromUser._id}`}
            className={classes.user}
          >
            <Avatar user={data.fromUser} size={80} />
            {data.fromUser.firstName}
          </ButtonBase>
        </TableCell>
      </TableRow>
    );
  }

  render() {
    const { classes, data } = this.props;
    if (!data.reports) {
      return <div />;
    }

    return (
      <div className={classes.container}>
        <Table className={classes.table}>
          <TableHead className={classes.tableHead}>
            <TableRow>
              <TableCell>Time</TableCell>
              <TableCell>Dismissed</TableCell>
              <TableCell>Reason</TableCell>
              <TableCell>Match</TableCell>
              <TableCell>Message</TableCell>
              <TableCell>Author</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.reports.map(item => this.renderRow(item))}
          </TableBody>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.userProfile.data
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {}
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(styled(TabReports))
);
